import gql from 'graphql-tag';

import { getLanguageWithoutFormality } from 'src/data/generation';
import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation TestCustomToneOfVoice(
    $customerId: ID!
    $text: String!
    $html: String
    $generationTool: GenerationToolEnum!
    $tovInput: TovInput!
    $language: String
    $structureInstructionsData: JSON
  ) {
    testCustomToneOfVoice(
      customerId: $customerId
      text: $text
      html: $html
      generationTool: $generationTool
      tovInput: $tovInput
      language: $language
      structureInstructionsData: $structureInstructionsData
    ) {
      originalCopyText
      modifiedCopyText
      modifiedCopyHtml
      tovParams {
        draftTov {
          traits {
            trait
            butNot
          }
          personality
          description
        }
      }
    }
  }
`;

export const testCustomToneOfVoice = async (
  { customerId, text, html, generationTool, tovInput, language, structureInstructionsData },
  options
) => {
  const variables = {
    customerId,
    text,
    html,
    generationTool,
    tovInput,
    language: getLanguageWithoutFormality(language),
    structureInstructionsData: stringifyIfPresent(structureInstructionsData),
  };

  // "text" is a required parameter currently, so in case "html" is provided, we need to set "text" to empty string
  if (html && !text) {
    variables.text = '';
  }

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
